import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { GET_TREATMENT_DETAILS } from "../../constants/treatment-list-const/TreatmentListConst";


const GET_TREATMENT_DETAILS_QUERY = gql`
query GetTreatmentDetails($slug: String!, $getTreatmentDetailsId: Int, $isNeedDefaultImage: Boolean) {
  getTreatmentDetails(slug: $slug, id: $getTreatmentDetailsId, isNeedDefaultImage: $isNeedDefaultImage) {
    success
    message
    data {
      treatment_details {
        treatment_id
        treatment_name
        treatment_image
        sent_medical_form_email
        treatment_images {
          image_id
          image_url
          orderNo
        }
        treatment_price
        treatment_description
        treatment_duration
        treatment_deposit
        treatment_categories {
          ctc_id
          ctc_trt_cat_id
          trt_cat_name
        }
        treatment_products {
          ctp_id
          ctp_product_id
          ctp_product_name
        }
        aftercare_docs {
          aftcr_dc_name
          aftcr_dc_id
        }
        treatment_locations {
          cln_id
          cln_name
        }
        consent_forms {
          con_frm_id
          con_frm_name
        }
      }
    }
  }
}
`;

var page;
export const GetTreatmentsDetails = () => {
    const dispatch = useDispatch();
    const [getClinicTreatmentDetails, userTreatmentDetailsData] = useLazyQuery(
        GET_TREATMENT_DETAILS_QUERY,
        {
          fetchPolicy: "cache-and-network",
          nextFetchPolicy: "cache-and-network",
          onCompleted: ({  getTreatmentDetails: responseData }) => {

            
            dispatch({
              type: GET_TREATMENT_DETAILS,
              payload: responseData.data
            });
            if (responseData.success) {
               
            } else {
              
            }
    
    
          },
        }
      );
      const userTreatmentDetailsQueryData = userTreatmentDetailsData;
  const initGetTreatmentDetailsForUser = (data, errorCallback) => {
    page = data?.page ? data?.page : 1
    getClinicTreatmentDetails({
      variables: data,
    }).then(res => {
      console.log('resresresresresresresresresresresresresres', res);
      const resData = res.data.getTreatmentDetails;
      if(!resData.success) {
        errorCallback && errorCallback(resData);
      }
    });
  };
  return {  initGetTreatmentDetailsForUser, userTreatmentDetailsQueryData };
};

// export function setUserBusinessReg(data) {
//     return {
//       type: GET_TREATMENTS_FOR_USER,
//       payload: data,
//     };
//   }


const GENERATE_CLINIC_OR_TREATMENT_DESC_QUERY = gql`
    query GenerateClinicOrTreatmentDesc($type: Int!, $clinicName: String, $treatmentName: String) {
        generateClinicOrTreatmentDesc(
            type: $type
            clinic_name: $clinicName
            treatment_name: $treatmentName
        ) {
            success
            message
            data {
                content
                type
            }
        }
    }
`;

export const GenerateClinicOrTreatmentDescAction = () => {
    const [fetchFn, generateClinicOrTreatmentDescStatus] = useLazyQuery(
        GENERATE_CLINIC_OR_TREATMENT_DESC_QUERY,
        {
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'cache-and-network',
        }
    );

    const generateClinicOrTreatmentDesc = (data, successCallback, errorCallback) => {
        fetchFn({ variables: data })
            .then((res) => {
                const resData = res.data.generateClinicOrTreatmentDesc;
                if (resData.success) {
                    successCallback && successCallback(resData.data);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { generateClinicOrTreatmentDescStatus, generateClinicOrTreatmentDesc };
};


const GET_CATEGORY_LIST_QUERY = gql`
  query GetCategoryList($page: Int, $limit: Int) {
    getCategoryList(page: $page, limit: $limit) {
      success
      message
      data {
        items {
          categoryId
          categoryName
        }
        total
        hasMore
      }
    }
  }
`;

export const GetCategoryListAction = () => {
    const [queryFn, getCategoryListStatus] = useLazyQuery(GET_CATEGORY_LIST_QUERY, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-and-network',
    });

    const initGetCategoryList = (data, successCallBack, errorCallback) => {
        queryFn({
            variables: data,
        })
            .then((res) => {
                const resData = res.data.getCategoryList;
                console.log('resData: ', resData);
                if (resData.success) successCallBack && successCallBack(resData.data);
                else errorCallback && errorCallback(resData);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    };

    return { getCategoryListStatus, initGetCategoryList };
};

const CREATE_OR_UPDATE_TREATMENT_MUTATION = gql`
  mutation CreateOrUpdateTreatment($clinicTreatmentId: Int, $clinicId: [Int], $treatmentDesc: String, $treatmentName: String, $depositAmount: Float, $treatmentPrice: Float, $treatmentTime: Int, $categoryId: [Int], $treatmentImages: [Upload], $productId: [Int], $aftercareFormId: [Int], $consentFormId: [Int], $sendMedicalFormDetails: Int) {
    createOrUpdateTreatment(clinic_treatment_id: $clinicTreatmentId, clinic_id: $clinicId, treatment_desc: $treatmentDesc, treatment_name: $treatmentName, deposit_amount: $depositAmount, treatment_price: $treatmentPrice, treatment_time: $treatmentTime, category_id: $categoryId, treatment_images: $treatmentImages, product_id: $productId, aftercare_form_id: $aftercareFormId, consent_form_id: $consentFormId, sent_medical_form_email: $sendMedicalFormDetails) {
      success
      message
    }
  }
`;

export const CreateOrUpdateTreatmentAction = () => {
    const [mutateFn, createOrUpdateTreatmentStatus] = useMutation(CREATE_OR_UPDATE_TREATMENT_MUTATION);

    const initCreateOrUpdateTreatment = (data, successCallback, errorCallback) => {
        mutateFn({
            variables: data,
        })
            .then((responseData) => {
                console.log('createOrUpdateTreatment--responseData', responseData)
                const resData = responseData.data.createOrUpdateTreatment;
                if (resData.success) {
                    successCallback && successCallback(resData);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { createOrUpdateTreatmentStatus, initCreateOrUpdateTreatment };
};

const DELETE_TREATMENT_MUTATION = gql`
  mutation DeleteTreatment($treatmentId: Int!) {
    deleteTreatment(treatmentId: $treatmentId) {
      success
      message
    }
  }
`;

export const DeleteTreatmentAction = () => {
    const [mutateFn, deleteTreatmentStatus] = useMutation(DELETE_TREATMENT_MUTATION);

    const initDeleteTreatment = (data, successCallback, errorCallback) => {
      mutateFn({
        variables: data,
      })
        .then((responseData) => {
          // console.log('deleteTreatment--responseData', responseData)
          const resData = responseData.data.deleteTreatment;
          if (resData.success) {
            successCallback && successCallback(resData);
          } else {
            errorCallback && errorCallback(responseData);
          }
        })
        .catch((err) => {
          errorCallback && errorCallback(err);
        });
    };

  return { deleteTreatmentStatus, initDeleteTreatment };
};

const CREATE_OR_UPDATE_CATEGORY_MUTATION = gql`
  mutation CreateOrUpdateCategory($categoryId: Int, $categoryName: String) {
    createOrUpdateCategory(categoryId: $categoryId, categoryName: $categoryName) {
      success
      message
      data {
        categoryId
      }
    }
  }
`;

export const CreateOrUpdateCategoryAction = () => {
    const [mutateFn, createOrUpdateCategoryStatus] = useMutation(CREATE_OR_UPDATE_CATEGORY_MUTATION);

    const initCreateOrUpdateCategory = (data, successCallback, errorCallback) => {
        mutateFn({
            variables: data,
        })
            .then((responseData) => {
                const resData = responseData.data.createOrUpdateCategory;
                if (resData.success) {
                    successCallback && successCallback(resData);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { createOrUpdateCategoryStatus, initCreateOrUpdateCategory };
};

const SAVE_TREATMENT_PHOTO_MUTATION = gql`
  mutation SaveTreatmentPhoto($clinicTreatmentId: Int, $image: Upload) {
    saveTreatmentPhoto(clinicTreatmentId: $clinicTreatmentId, image: $image) {
      success
      message
      data {
        id
        imageUrl
      }
    }
  }
`;

export const SaveTreatmentPhotoAction = () => {
    const [mutateFn, saveTreatmentPhotoStatus] = useMutation(SAVE_TREATMENT_PHOTO_MUTATION);

    const initSaveTreatmentPhoto = (data, successCallback, errorCallback) => {
        mutateFn({
            variables: data,
        })
            .then((responseData) => {
                const resData = responseData.data.saveTreatmentPhoto;
                if (resData.success) {
                    successCallback && successCallback(resData?.data);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { saveTreatmentPhotoStatus, initSaveTreatmentPhoto };
};

const DELETE_TREATMENT_PHOTO_MUTATION = gql`
  mutation DeleteTreatmentPhoto($imageId: Int) {
    deleteTreatmentPhoto(imageId: $imageId) {
      success
      message
    }
  }
`;

export const DeleteTreatmentPhotoAction = () => {
    const [mutateFn, deleteTreatmentPhotoStatus] = useMutation(DELETE_TREATMENT_PHOTO_MUTATION);

    const initDeleteTreatmentPhoto = (data, successCallback, errorCallback) => {
        mutateFn({
            variables: data,
        })
            .then((responseData) => {
                const resData = responseData.data.deleteTreatmentPhoto;
                if (resData.success) {
                    successCallback && successCallback(resData);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { deleteTreatmentPhotoStatus, initDeleteTreatmentPhoto };
};


const DELETE_TREATMENT_CATEGORY_MUTATION = gql`
  mutation DeleteTreatmentCategory($deleteTreatmentCategoryId: Int) {
  deleteTreatmentCategory(id: $deleteTreatmentCategoryId) {
    success
    message
  }
}
`;

export const DeleteTreatmentCategoryAction = () => {
    const [mutateFn, deleteTreatmentCategoryStatus] = useMutation(DELETE_TREATMENT_CATEGORY_MUTATION);

    const initDeleteTreatmentCategory = (data, successCallback, errorCallback) => {
      mutateFn({
        variables: data,
      })
        .then((responseData) => {
          // console.log('deleteTreatment--responseData', responseData)
          const resData = responseData.data.deleteTreatmentCategory;
          if (resData.success) {
            successCallback && successCallback(resData);
          } else {
            errorCallback && errorCallback(responseData);
          }
        })
        .catch((err) => {
          errorCallback && errorCallback(err);
        });
    };

  return { deleteTreatmentCategoryStatus, initDeleteTreatmentCategory };
};